export const formatDate = (date, locale = undefined) => {
  if (date) {
    const jsLocale = locale && locale?.indexOf('_') > 0 ? locale.replace('_', '-') : locale; // make nl_BE -> nl-BE (see mdn)
    return new Date(date).toLocaleString(jsLocale, {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
    });
  }
  return 0;
};

export const toISODate = (date) => (date ? date.toISOString().split('T')[0] : 0);

export const weeksBetween = (d1, d2) => Math.round((d2 - d1) / (7 * 24 * 60 * 60 * 1000));

export const timeExpired = (lastUpdate) => {
  const previous = new Date(lastUpdate).getTime();
  const current = new Date().getTime();

  return (current - previous) > process.env.VUE_APP_DATA_CACHE_TIME;
};

export default formatDate;
